export enum WorldpayFormField {
  Address = 'address',
  BillingAddress = 'billingAddress',
  PaperlessPreference = 'paperlessPreference',
  TermsAndConditions = 'termsAndConditions',
}
